/* eslint-disable import/prefer-default-export */

export const ADDING_ACCOUNT_CHANGED = 'ADDING_ACCOUNT_CHANGED';
export const AUTHORIZED_PAGE_DELETED = 'AUTHORIZED_PAGE_DELETED';
